import React from 'react';
import { Link } from 'gatsby';
import { Nav, NavItem, NavLink } from 'reactstrap';

type linkProps = {
  key: string;
  url: string;
  linkTitle: string;
};

const NavSection = (props: { title: string; list: linkProps[] }) => {
  return (
    <div className="mb-3 pb-3">
      <p className="mb-0 dp-font-lg">{props.title}</p>
      <Nav vertical>
        {props.list.map((link: linkProps) => {
          return (
            <NavItem key={link.key}>
              <NavLink
                tag={Link}
                to={link.url}
                className="text-primary dp-font-sm"
              >
                {link.linkTitle}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
    </div>
  );
};

const JobIndexAside = (props: {
  similarPositionsLinks: linkProps[];
  matchingSalariesLinks: linkProps[];
  synonymsLinks: linkProps[];
}) => {
  return (
    <>
      {props.similarPositionsLinks.length > 0 && (
        <NavSection
          title="Related categories:"
          list={props.similarPositionsLinks}
        />
      )}
      {props.matchingSalariesLinks.length > 0 && (
        <NavSection title="See also:" list={props.matchingSalariesLinks} />
      )}
      {props.synonymsLinks.length > 0 && (
        <NavSection
          title="People also searched for:"
          list={props.synonymsLinks}
        />
      )}
    </>
  );
};

export default JobIndexAside;
